<app-admin-page-model routeName="Modification d'utilisateurs" pageTitle="Liste des demandes de modification d'utilisateur">
  <app-user-requests [requests]="requests"/>
</app-admin-page-model>
